import { useState } from "react";
import { toast } from "sonner";
import { Check, MessageCircle } from "lucide-react";
import { api, errMsg, waLink } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const Fila = ({ p, n, enviado, onSend }) => {
  const [tel, setTel] = useState(p.telefono || "");
  const enviar = async () => {
    if (!tel.trim()) return toast.error(`Escribe el móvil de ${p.nombre}`);
    if (tel.trim() !== (p.telefono || "")) {
      try {
        await api.post(`/profesionales/${p.id}/telefono`, { telefono: tel.trim() });
        p.telefono = tel.trim();
      } catch (e) {
        return toast.error(errMsg(e));
      }
    }
    onSend(p, tel.trim());
  };
  return (
    <div className="flex items-center gap-2 py-1.5" data-testid={`wa-todas-${p.id}`}>
      <span className="h-3 w-3 rounded-sm" style={{ background: p.color }} />
      <span className="flex-1 text-sm">{p.nombre} <span className="text-xs text-slate-500">· {n} cita{n === 1 ? "" : "s"}</span></span>
      <Input type="tel" value={tel} onChange={(e) => setTel(e.target.value)} placeholder="Móvil" className="h-8 w-32" data-testid={`wa-todas-tel-${p.id}`} />
      <Button size="sm" onClick={enviar} data-testid={`wa-todas-send-${p.id}`} className={enviado ? "bg-slate-400 hover:bg-slate-500" : "bg-emerald-600 hover:bg-emerald-700"}>
        {enviado ? <><Check className="h-3.5 w-3.5 mr-1" />Abierto</> : <><MessageCircle className="h-3.5 w-3.5 mr-1" />Enviar</>}
      </Button>
    </div>
  );
};

export const WaTodas = ({ profs, contar, mensaje, fechaTxt, label = "WhatsApp a todas", testId = "agenda-wa-todas" }) => {
  const [open, setOpen] = useState(false);
  const [hechos, setHechos] = useState([]);
  const lista = profs.filter((p) => contar(p) > 0);
  const send = (p, tel) => {
    window.open(waLink(tel, mensaje(p)), "_blank");
    setHechos((h) => [...h, p.id]);
  };
  const siguiente = lista.find((p) => !hechos.includes(p.id));
  return (
    <>
      <button type="button" onClick={() => { setHechos([]); setOpen(true); }} data-testid={testId}
        className="inline-flex items-center gap-1 rounded-md border border-emerald-300 bg-white px-2.5 py-1 font-medium text-emerald-700 hover:bg-emerald-50"><MessageCircle className="h-3.5 w-3.5" />{label}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="wa-todas-dialog">
          <DialogHeader><DialogTitle className="font-[Outfit]">Citas del {fechaTxt} a cada profesional</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500 -mt-2">Pulsa «Enviar» en cada una: se abre su WhatsApp con el mensaje escrito; envíalo y vuelve aquí para la siguiente.</p>
          {lista.length ? <div className="divide-y divide-slate-100">{lista.map((p) => <Fila key={p.id} p={p} n={contar(p)} enviado={hechos.includes(p.id)} onSend={send} />)}</div>
            : <p className="text-sm text-slate-500">Nadie tiene citas este día.</p>}
          <div className="flex items-center justify-between pt-1">
            <span className="text-xs text-slate-500" data-testid="wa-todas-progreso">{hechos.length}/{lista.length} abiertos</span>
            {siguiente ? <Button onClick={() => { const t = siguiente.telefono; if (!t) return toast.error(`Falta el móvil de ${siguiente.nombre}`); send(siguiente, t); }} data-testid="wa-todas-siguiente" className="bg-emerald-600 hover:bg-emerald-700">Enviar a la siguiente: {siguiente.nombre.split(" ")[0]}</Button>
              : lista.length > 0 && <span className="text-sm font-medium text-emerald-700">¡Todas preparadas!</span>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
